import React from "react";
import MetricGroup from "./MetricGroup";
import "./style.css";

// Todo: Styling is repeating for each component.
//  Can we live with this or should global styles
//  be created? How does style-components handle
//  relationships between components?

const StyledMetrics = ({ children, ...rest }) => (
  <div className="metrics" {...rest}>
    {children}
  </div>
);

const StyledColumn = ({ children, ...rest }) => (
  <div className="metrics-column" {...rest}>
    {children}
  </div>
);

const StyledRow = ({ children, ...rest }) => (
  <div className="metrics-row" {...rest}>
    {children}
  </div>
);

const MetricTitle = ({ children, ...rest }) => (
  <div className="metrics-title" {...rest}>
    {children}
  </div>
);

export const speakers = {
  AGENT: "Agent",
  CUSTOMER: "Customer",
  CALLER: "Customer",
  BOT: "Bot",
  OVERALL: "Overall",
};

/* eslint react/prefer-stateless-function:0 */
class Index extends React.PureComponent {
  render() {
    const {
      metrics,
      metricGroups,
      title,
      isChatTextMedia = false,
    } = this.props;
    if (!(metrics && _.isArray(metrics))) {
      return <p>Metrics data for this file is not properly formatted. </p>;
    }

    // Bot speaker column should not display for speech media types
    const filteredSpeakers = Object.keys(speakers).filter((speaker) => {
      return isChatTextMedia
        ? speaker !== "CALLER"
        : speaker !== "BOT" && speaker !== "CALLER";
    });
    return (
      <StyledMetrics>
        {metrics.map((group) => (
          <StyledColumn key={`${title}_${group.metricGroupName}`}>
            <StyledRow>
              <div />
              {/* Filter out 'CALLER' as this is synonymous with 'CUSTOMER' */}
              {filteredSpeakers.map((speaker) => (
                <h4 className="fw5">{speakers[speaker]}</h4>
              ))}
            </StyledRow>
            <MetricGroup
              {...group}
              filteredSpeakers={filteredSpeakers}
              groupUnits={metricGroups}
            />
          </StyledColumn>
        ))}
      </StyledMetrics>
    );
  }
}

export default Index;
